<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="missionId"
            :search-url="searchUrl"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :deleteMulti="false"
            orderBy="desc"
            :acceptView=false
            :accept-create="false"
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/mission/MissionCreate";
import {message} from "@/shared/message";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Log bài học",
      searchUrl: null,
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'accountId',
          text: 'Account Id',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'profileid',
          text: 'profileid',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },

        {
          value: 'createDate',
          text: 'Ngày tạo',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy hh:mm:ss',
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'trigger_event',
          text: 'trigger_event',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'partid',
          text: 'partid',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'version',
          text: 'version',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'downloadtime',
          text: 'downloadtime',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'os',
          text: 'os',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'devicemodel',
          text: 'devicemodel',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'platform',
          text: 'platform',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'deviceid',
          text: 'deviceid',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'devicename',
          text: 'devicename',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'devicetype',
          text: 'devicetype',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'stepid',
          text: 'stepid',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'isusingvoicekidsapi',
          text: 'isusingvoicekidsapi',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'time_start',
          text: 'time_start',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'time_end',
          text: 'time_end',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'point',
          text: 'point',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },



      ]
    };
  },

  methods: {

  },
  created() {
    this.searchUrl ="/kidAccountClass/searchTrackingByPhone/" + this.$route.params.phone + "?sortField=status,classId&";
  }


};
</script>
